module.exports = __webpack_public_path__ + "img/thumbs-up.bf12c4d7.svg";